import {logger} from 'tizra'
import * as B from '../block'

const log = logger('ImageBlock/Simple')

interface SimpleProps {
  imageUrl: string
  altText: string
  setErrored: (url: string) => void
  linkUrl: string
}

export const Simple = ({
  imageUrl,
  altText,
  setErrored,
  linkUrl,
}: SimpleProps) => {
  let image = (
    <B.Image
      src={imageUrl}
      alt={altText}
      fluid
      onError={() => setErrored(imageUrl)}
      {...B.tid('ImageBlock-img')}
    />
  )

  if (linkUrl) {
    image = (
      <B.UniversalLink
        href={linkUrl}
        {...B.tid('ImageBlock-link')}
        style={{display: 'block'}}
      >
        {image}
      </B.UniversalLink>
    )
  }

  return image
}
